import { Component, OnInit, Input } from '@angular/core';
import { AppComponent} from '../../app.component';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AlertService } from '../../alertpopup/_alert';
export class EscalationReportLevelData{
  LevelID:any;
  MailTemplate:any;
  recEnable:any;
}

export class EscalationReportData {
  ReportID:any;
  FeatureDs : string;
  EDList: EscalationReportLevelData[];
}

@Component({
    selector: 'app-escalation-report-entry',
    templateUrl: './escalation-report-entry.component.html',
    styleUrls: ['./escalation-report-entry.component.css'],
    standalone: false
})
export class EscalationReportEntryComponent implements OnInit {
  url: string;
  EscalationEntry: FormGroup;
  EscalationData: EscalationReportData;
  ReportID: any;
  pageurl: string;
  postString:string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    // this.EscalationEntry = this.formBuilder.group({
    // });
    const formGroup = {};
    formGroup['ReportID'] = new FormControl("");
    this.EscalationEntry = new FormGroup(formGroup);
    this.EscalationData = new EscalationReportData();
    //this.EscalationData.EDList = new EscalationUserDataV2[];

    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.ReportID = pagehead[2];

    this.LoadData();
  }

  LoadData()
  {
    this.http.get(this.url + 'AlertNotificationDetail/GetEscalationFeatureData?FeatureID=' + this.ReportID)
    .subscribe( (data) => {
        if (data == null || data.toString() == "[]") {
        }
        else {
          this.EscalationData = JSON.parse(data.toString());

           const formGroup = {};
           formGroup['ReportID'] = new FormControl("");

           // Build Dynamic Form Control Name
           this.EscalationData.EDList.forEach(ed => {
             formGroup['MailTemplate_' + ed.LevelID] = new FormControl("");
             formGroup['LevelID_' + ed.LevelID] = new FormControl("");
             formGroup['recEnable_' + ed.LevelID] = new FormControl("");
             this.EscalationEntry = new FormGroup(formGroup);
           });

          // Patch Values
          for (var val of this.EscalationData.EDList) {
            (this.EscalationEntry.get(String('LevelID_' + val.LevelID)) as FormControl).patchValue(val.LevelID);
            (this.EscalationEntry.get(String('MailTemplate_' + val.LevelID)) as FormControl).patchValue(val.MailTemplate);
            (this.EscalationEntry.get(String('recEnable_' + val.LevelID)) as FormControl).patchValue(val.recEnable);
          }

        }
      },
      (error) => {
       }
    );
  }

  onEscalationSubmit(Data)
  {
    if(Data.Employee < 1)
    {
      this.alertService.warn('Please select employee', this.options);
      return;
    }

    this.postString="";

    for (var val of this.EscalationData.EDList) {
      this.postString += (this.postString != ""? "|":"");
      this.postString += (this.EscalationEntry.get(String('ID_' + val.LevelID)) as FormControl).value + '~';
      this.postString += (this.EscalationEntry.get(String('LevelID_' + val.LevelID)) as FormControl).value + '~';
      if((this.EscalationEntry.get(String('Users_' + val.LevelID)) as FormControl).value != null)
        this.postString += (this.EscalationEntry.get(String('Users_' + val.LevelID)) as FormControl).value + '~';
      else
        this.postString += '~';
      this.postString += (this.EscalationEntry.get(String('Day_' + val.LevelID)) as FormControl).value + '~';
      this.postString += (this.EscalationEntry.get(String('Interval_' + val.LevelID)) as FormControl).value + '~';
      //(this.EscalationEntry.get(String('recEnable_' + val.LevelID)) as FormControl).patchValue(val.recEnable);
    }

    let postData={
      ReportID : this.ReportID,
      UserID : (this.EscalationEntry.get(String('Employee')) as FormControl).value,
      EmailSetting: this.postString
    };


    this.http.post(this.url + 'AlertNotificationDetail/UpdateEscalation', postData) .subscribe( (data) => {
      if (data == null) {
        this.alertService.error('An Error Occurred', true);
      } else {
        this.alertService.success(data.toString() , this.options);
      }
     }
   );
  }

}
